var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useId, useRef } from 'react';
import { Box, IconBackground, Link, LinkExternalIcon, Loading02Icon, Modal, Trans, Typography, } from '@lucidlink/uicore';
import { LUCIDLINK_STATUS_PAGE } from '#constants';
import { useDependency } from '#context';
import { useHealthCheck } from '#query-hooks';
const MIN_DISPLAY_MS = 5_000;
const REQUIRED_SUCCESSES = 3;
const noop = () => { };
export const ServiceUnavailableModal = ({ closeModal, }) => {
    _react_refresh_temp_2();
    const titleId = useId();
    const queryClient = useQueryClient();
    const serviceUnavailableMessage = useDependency('serviceUnavailableViewMessage');
    const { query } = useHealthCheck();
    const mountedAt = useRef(Date.now());
    const successCount = useRef(0);
    useEffect(() => {
        if (query.status === 'success') {
            successCount.current++;
        }
        else {
            successCount.current = 0;
        }
        if (successCount.current < REQUIRED_SUCCESSES) {
            return;
        }
        const elapsed = Date.now() - mountedAt.current;
        const remaining = Math.max(0, MIN_DISPLAY_MS - elapsed);
        const timeout = setTimeout(() => {
            void queryClient.invalidateQueries();
            closeModal();
        }, remaining);
        return () => {
            clearTimeout(timeout);
        };
    }, [query.status, query.dataUpdatedAt, closeModal, queryClient]);
    return (_jsx(Modal, { "aria-labelledby": titleId, 
        // Passing `noop` here to prevent Escape key from closing the modal, as that part of the code is not guarded
        // by `shouldCloseOnOverlayClick` or any other flag. Behavior might not be what we want, but it works.
        closeModal: noop, "data-testid": "service-unavailable", shouldCloseOnOverlayClick: false, shouldHaveCloseButton: false, children: _jsxs(Box, { align: "center", gap: "xl", orientation: "vertical", children: [_jsx(IconBackground, { color: "orange", "data-testid": "service-unavailable", Icon: Loading02Icon, size: "large" }), _jsxs(Box, { align: "center", gap: "sm", orientation: "vertical", children: [_jsx(Typography, { align: "center", as: "h2", color: "accent", id: titleId, kind: "h3", children: _jsx(Trans, { children: "Our servers are temporarily unavailable" }) }), _jsx(Typography, { align: "center", kind: "p", children: serviceUnavailableMessage() })] }), _jsx(Link, { "data-testid": "system-status", EndIcon: LinkExternalIcon, kind: "subtle", target: "_blank", to: LUCIDLINK_STATUS_PAGE, children: _jsx(Trans, { children: "Check system status" }) })] }) }));
};
_react_refresh_temp_1 = ServiceUnavailableModal;
$RefreshReg$(_react_refresh_temp_1, "ServiceUnavailableModal");
_react_refresh_temp_2(ServiceUnavailableModal, "cl4YZv4Os3MF6lI+3oexIKglrxw=", false, () => [useQueryClient, useDependency, useHealthCheck]);
